import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Buttons,
  FlexContainer,
  InputFormTypes,
  Inputs,
  Text,
  useForm,
} from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import {
  hideModalAction,
  setIsLoadingAction,
  setIsNotLoadingAction,
} from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import FormContainer from 'Components/UI/FormContainer';
import { routes } from 'Constants/routes';
import { UpdateSatPasswordProp } from './types';
import { useFetchUpdateSatPassword } from './hooks';

const initialState = {
  password: {
    value: '',
    isValid: false,
  },
};

const UpdateSatPassword = ({ satPassword }: UpdateSatPasswordProp): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);
  const { formValues, isValidForm, onInputChange } = useForm(initialState);
  const dispatch = useDispatch();
  const closeModal = (): void => {
    dispatch(hideModalAction());
    dispatch(setIsNotLoadingAction());
  };
  const { mutate, isLoading } = useFetchUpdateSatPassword({
    onHideModal: closeModal,
    route: routes.ACCOUNT,
  });

  useEffect(() => {
    if (satPassword) {
      onInputChange({ id: 'password', value: satPassword, isValid: true });
    }
  }, [satPassword]);

  useEffect(() => {
    if (isLoading) {
      dispatch(setIsLoadingAction());
    }
  }, [isLoading]);

  const handleSubmit = (e: React.ChangeEvent): void => {
    e.preventDefault();
    const { password } = formValues;
    mutate({ password: password.value?.toString() ?? '' });
  };
  return (
    <FlexContainer direction="column" gap="dimension_16">
      <Text type="headline" size="L_S_S" color="dark">
        {t('UpdateSatPassword.title')}
      </Text>
      <FormContainer onSubmit={handleSubmit}>
        <FlexContainer direction="column" gap="dimension_16">
          <Inputs.InputForm
            inputForm={{
              id: 'password',
              label: t('InputSat.title'),
              type: InputFormTypes.PASSWORD,
              placeholder: t('dg:DGRfc.Password.placeholder'),
              info: t('dg:DGRfc.Password.info'),
              validationType: 'Required',
              validations: {
                required: true,
              },
            }}
            value={formValues.password.value?.toString()}
            onChange={(value, isValid) => onInputChange({ id: 'password', value, isValid })}
          />
          <Buttons.Classic
            mode="success"
            size="m"
            label={t('UpdatePhone.CTA')}
            fullWidth
            disabled={!isValidForm}
            testID="signInSubmit"
            type="submit"
          />
        </FlexContainer>
      </FormContainer>
    </FlexContainer>
  );
};

export default UpdateSatPassword;
